import React, { useState, useEffect } from "react"

// components
import Label from "components/Label/Label"

const RowTotal = (props) => {
  let { category, hideTotal } = props

  const { measure, baselineData } = props

  const isCountUnits = measure?.selected_unit_of_analysis === "U"

  const { totalParticipants, totalUnits } = React.useMemo(() => {
    if (category?.values) {
      let values = category?.values?.map((val) => {
        let key = "value"
        if (isNaN(Number(val?.[key]))) return 0
        if (val[key]) return Number(val[key])
        else if (val[key]) return Number(val[key])
        return 0
      })

      let totalUnits = category?.values?.map((val) => {
        let key = "num_units_analyzed"
        if (isNaN(Number(val?.[key]))) return 0
        if (val[key]) return Number(val[key])
        else if (val[key]) return Number(val[key])
        return 0
      })

      return {
        totalParticipants: values.reduce((acc, val) => acc + Number(val), 0),
        totalUnits: totalUnits.reduce((acc, val) => acc + Number(val), 0),
      }
    }
  }, [baselineData])

  if (hideTotal) {
    return (
      <td className="total-col text-right">
        <Label>-</Label>
      </td>
    )
  }

  let label = "Total Participants: "
  if (isCountUnits) label = `Total Units (${baselineData?.ctg?.type_units_analyzed || "NA"}): `

  if (category.id === "num-analyzed" && isCountUnits) {
    return (
      <td className="total-col text-right">
        {isCountUnits && (
          <Label style={{ marginBottom: ".3rem", width: "100%" }}>Total Participants: {totalParticipants}</Label>
        )}
        <Label style={{ marginBottom: ".3rem", width: "100%" }}>
          {label} {totalUnits}
        </Label>
      </td>
    )
  }

  return (
    <td className="total-col text-right">
      <Label style={{ marginBottom: ".3rem", width: "100%" }}>
        {label} {totalParticipants}
      </Label>
    </td>
  )
}

export default RowTotal
